import React from 'react';

const PhoneHistory = ({ history }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-4">Historial de Trazabilidad</h2>
      <div className="space-y-4">
        {history.length === 0 ? (
          <p className="text-gray-500">No hay historial registrado</p>
        ) : (
          history.map((entry, index) => {
            const hasFailureCode = entry.comment && entry.comment.includes(':');
            const code = hasFailureCode ? entry.comment.split(':')[0] : '';
            const comment = hasFailureCode ? entry.comment.split(':')[1].trim() : entry.comment;

            return (
              <div key={index} className="border-l-4 pl-4 py-2" style={{ borderColor: entry.result === 'pass' ? '#10B981' : '#EF4444' }}>
                <div className="flex justify-between">
                  <span className="font-medium">{entry.status}</span>
                  <span className="text-sm text-gray-500">{new Date(entry.timestamp).toLocaleString()}</span>
                </div>
                <div className="flex items-center mt-1">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                    entry.result === 'pass' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                  }`}>
                    {entry.result === 'pass' ? 'PASA' : 'FALLA'}
                  </span>
                  <span className="ml-2 text-sm text-gray-500">por {entry.user_name}</span>
                </div>
                {entry.result === 'fail' && (
                  <>
                    {code && (
                      <p className="mt-1 text-sm font-medium text-red-600">Código: {code}</p>
                    )}
                    {comment && (
                      <p className="mt-1 text-sm text-gray-700">{comment}</p>
                    )}
                  </>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default PhoneHistory;
